import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {} ,
  orderRequestSearchType: "",
  orderRequestSearchField: []
};

export const orderListSlice = createSlice({
  name: 'orderList',
  initialState,
  reducers: {
    add: (state, orderList) => {
      state.data = orderList;
    },
    setOrderRequestSearchType: (state, searchType) => {
      state.orderRequestSearchType = searchType;
    },
    setOrderRequestSearchField: (state, searchFieldData) => {
      state.orderRequestSearchField = searchFieldData;
    },
    purge: (state) => {
      state = initialState;
    }
  },
})

// Action creators are generated for each case reducer function
export const { add, setOrderRequestSearchType, setOrderRequestSearchField } = orderListSlice.actions;

export default orderListSlice.reducer;